/**
 * @license Copyright (c) 2003-2016, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */
CKEDITOR.config.customConfig = false;

let CKEditorConfig_default = {
    language: document.documentElement.lang,
    baseHref: '',
    removePlugins: 'wsc,scayt,image,print,sourcearea,magicline',
    removeButtons: 'Subscript,Superscript,Anchor,Styles,Scayt',
    ignoreEmptyParagraph: false,
    magicline_color: '#FFFFFF',
    autoParagraph: true,
    enterMode: CKEDITOR.ENTER_P,
    shiftEnterMode: CKEDITOR.ENTER_BR,
    height: 300,
    autoGrow_onStartup: true,
    autoGrow_bottomSpace: 20
};

let CKEditorConfig_line = {
    toolbarGroups : [
        { name: 'basicstyles', groups: [ 'basicstyles' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] }
    ],
    extraPlugins: 'autogrow',
    disallowedContent: '*',
    allowedContent: 'strong em',
    autoParagraph: false,
    enterMode: CKEDITOR.ENTER_BR,
    height: 80
};

let CKEditorConfig_basic = {
    toolbarGroups : [
        { name: 'basicstyles', groups: [ 'basicstyles' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find' ] }
    ],
    extraPlugins: 'find,autogrow',
    format_tags: 'p',
    allowedContent: 'p strong em',
    height: 80
};

let CKEditorConfig_simple = {
    toolbarGroups : [
        { name: 'basicstyles', groups: [ 'basicstyles' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'links' },
        { name: 'insert' },
        { name: 'editing', groups: [ 'find' ] }
    ],
    extraPlugins: 'find,link,autogrow',
    format_tags: 'p',
    allowedContent: 'p strong em a[*];',
    height: 160
};

let CKEditorConfig_normal = {
    toolbarGroups : [
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'paragraph', groups: [ 'align', 'list', 'blocks' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'links' },
        { name: 'insert' },
        { name: 'editing', groups: [ 'find' ] }
    ],
    extraPlugins: 'justify,panelbutton,find,link,autogrow,table,tabletools',
    format_tags: 'p;h1;h2;h3;h4;h5;h6',
    allowedContent: 'h1 h2 h3 h4 h5 h6 p blockquote{text-align}; strong em ul ol li table th td tr tbody tfoot thead hr; a[*];'
};

let CKEditorConfig_all = {
    toolbarGroups : [
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'paragraph', groups: [ 'align', 'list', 'blocks' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'links' },
        { name: 'colors' },
        { name: 'insert' },
        { name: 'editing', groups: [ 'find' ] }
    ],
    extraPlugins: 'justify,colorbutton,panelbutton,colordialog,find,table,tabletools,link,base64image,autogrow',
    format_tags: 'p;h1;h2;h3;h4;h5;h6',
    allowedContent: 'h1 h2 h3 h4 h5 h6 p img[alt,!src]{width,height}; blockquote{text-align,color,background-color}; strong em ul ol li table th td tr tbody tfoot thead hr; span{color,background-color}; a[*];'
};

// In frontend la modalita' 'expert' coincide con 'all' perche' non esistono
// i toolbar group translation e ai da escludere (presenti solo in backend).
let CKEditorConfig_expert = CKEditorConfig_all;